<template>
    <v-app>
        <!-- <core-filter /> -->
        <core-drawer />
        <core-toolbar />
        <core-view />
    </v-app>
</template>

<script>
import coreDrawer from '@/components/core/Drawer'
import coreToolbar from '@/components/core/Toolbar'
import coreView from '@/components/core/View'

export default {
    name: 'app',
    components: {
        coreDrawer,
        coreToolbar,
        coreView
    },
    methods: {
        handleLoginEvent (data) {
            // console.log('handle login event - hit')
            // console.log(data)
            //this.$store.dispatch('auth/authenticated', data.authResult)
        }
    }
}
</script>

<style lang="scss">
    @import '@/styles/index.scss';

    /* Remove in 1.2 */
    .v-datatable thead th.column.sortable i {
        vertical-align: unset;
    }

    .v-tabs .v-window__container {
        height: unset!important;
    }
</style>
